import $store from '@/store'
import $cookies from 'vue-cookies'
/**
 * 기본 쿼리스트링이 들어오면 쿠키에 셋팅 + 로그인?
 */
export default async (to, from, next) => {
  const {
    secret_token,
    company_name,
    business_license_number,
    firebase_token,
    phone,
    promotion_code,
    token,
    owner_name,
    referral_code,
    redirectUri,
    acquisitionRoute,
  } = to.query
  let { referralCode } = to.query
  if (referral_code) {
    referralCode = referral_code
  }
  let signinToken

  if (secret_token) {
    signinToken = secret_token
  }
  if (token) {
    signinToken = token
  }

  if (signinToken) {
    await $store.dispatch('auth/signinSuccess', {
      accessToken: signinToken,
      refreshToken: signinToken,
    })
  }

  if (business_license_number) {
    $cookies.set('businessLicenseNumber', business_license_number, 0)
  }
  if (company_name) {
    $cookies.set('companyName', company_name, 0)
  }
  if (firebase_token) {
    $cookies.set('firebaseToken', firebase_token, 0)
  }
  if (phone) {
    $cookies.set('phone', phone, 0)
  }
  if (promotion_code) {
    $cookies.set('promotionCode', promotion_code, 0)
  }
  if (owner_name) {
    $cookies.set('ownerName', owner_name, 0)
  }
  if (referralCode) {
    $cookies.set('referralCode', referralCode, 0)
  }

  if (redirectUri) {
    $cookies.set('redirectUri', redirectUri, 0)
  }

  if (acquisitionRoute) {
    $cookies.set('acquisitionRoute', acquisitionRoute, 0)
  }
  next()
}
